var map = {
	"./BubbleTea.jpeg": "f455",
	"./BurgerKing.jpeg": "a620",
	"./Dickson.jpeg": "3f48",
	"./DoughMagic.jpeg": "8b1a",
	"./FishSoup.jpeg": "da06",
	"./Hand-Luggage-Only-5-1.jpeg": "8d21",
	"./Korean.jpeg": "5101",
	"./MalaHotpot.jpeg": "6d73",
	"./Thai.jpeg": "3824",
	"./TheDeck.jpeg": "f107"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "604f";